import { useMemo } from "react";
import type {
  HotelRoomRateMeta,
  UseHotelRoomRatesSource,
} from "@b2bportal/core-types";
import type { RoomInfoProducts, RoomProduct } from "@b2bportal/lodging-api";
import { HotelRateView } from "../components/HotelRoomRate";

const noopSetSelectedRate = () => {};

export const useHotelRoomRatesSource: UseHotelRoomRatesSource = ({ room }) => {
  const rates = useMemo(() => {
    const productsWithRateId = room.products.filter(
      (product): product is ProductWithRateId =>
        product.rateId?.value !== undefined
    );

    if (productsWithRateId.length === 0) {
      return null;
    }

    return productsWithRateId.map((product) =>
      createHotelRoomRateMeta(product, room.pricingDifference)
    );
  }, [room]);

  return { rates };
};

type ProductWithRateId = RoomProduct & { rateId: { value: string } };

const createHotelRoomRateMeta = (
  product: ProductWithRateId,
  pricingDifference: RoomInfoProducts["pricingDifference"] | undefined
): HotelRoomRateMeta => {
  const priceDifference =
    pricingDifference?.[product.rateId.value]
      ?.priceDifferenceTaxesAndFeesIncluded;

  return {
    key: product.rateId.value,
    origin: "hotel",
    product,
    View: HotelRateView,
    priceDifference,
    setSelectedRate: noopSetSelectedRate,
  };
};
